import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

// import "../app-invoice.css";
import { getMRTimelLineDocReport } from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";

class MRTimelLineReportDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getMRTimelLineDocReport(this.props.match.params.id);
  }
  formatDate = (date) => (date ? moment(date).format("DD-MM-YYYY") : "-");

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pxToMm = 25.4 / 96;
    const imgWidthMM = canvas.width * pxToMm;
    const imgHeightMM = canvas.height * pxToMm;

    const scale = pageWidth / imgWidthMM;
    const scaledWidth = imgWidthMM * scale;
    const scaledHeight = imgHeightMM * scale;

    let yPos = 0;
    let xPos = 0;
    let remainingHeight = scaledHeight;
    let remainingWidth = scaledWidth;

    while (remainingHeight > 0) {
      while (remainingWidth > 0) {
        pdf.addImage(imgData, "PNG", -xPos, -yPos, scaledWidth, scaledHeight);

        remainingWidth -= pageWidth;
        xPos += pageWidth;

        if (remainingWidth > 0) pdf.addPage();
      }

      remainingWidth = scaledWidth;
      xPos = 0;
      remainingHeight -= pageHeight;
      yPos += pageHeight;

      if (remainingHeight > 0) pdf.addPage();
    }

    pdf.save("mrtimeline_report.pdf");
  };

  // componentDidUpdate() {
  //   console.log("Error in id: ", this.props.match.params.id);
  //   console.log(
  //     "Error in MRTimelLineReportDocument",
  //     this.props.MRTimeLine_Doc_report
  //   );
  // }
  reportBody() {
    const data = this.props.MRTimeLine_Doc_report;

    if (!data) return null;
    return (
      <Row className="p-1 report-preview">
        <Col md={12} className="p-1">
          <Card className="p-1 report-preview-card">
            <CardBody className="report-padding pb-0">
              <div className="report-body flex-sm-row flex-column  mt-0">
                <div className=" ">
                  <h5 className="card-title-16 pt-2 ">
                    SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                  </h5>
                  <p className="card-title-14 pt-2 mb-0">
                    Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP
                  </p>
                  <p className="card-title-14 pt-2 mb-0">
                    Phone No.0884-2326661, 62, Mobile No.9494127893,
                  </p>
                  <p className="card-title-14 pt-2 mb-0">
                    Email: purchase@sleipl.com, lalitharice@gmail.com
                  </p>
                  <p className="card-title-14 pt-2">GSTIN : 37AAKCS3233N1ZX</p>
                </div>
                <div className="pt-2">
                  <span className="p-4">
                    <img
                      className="img-fluid p-0"
                      src={SLE_logo}
                      alt="Logo"
                      width="100"
                      height="120"
                    />
                  </span>
                  <h4 className="report-title mb-0">MR TIMELINE REPORT</h4>
                  <h5 className="report-title">
                    <span className="report-number">
                      #{this.props.MRTimeLine_Doc_report?.mr_no}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="hr-black-color " />

              <div className="report-body d-flex justify-content-between">
                <div>
                  <p>
                    <strong>Created By:</strong> {data.createdby?.fullname}
                  </p>
                  <p>
                    <strong>MR Date:</strong> {data.createdon}
                  </p>
                </div>

                <div>
                  <p>
                    <strong>Department:</strong> {data.department?.name}
                  </p>
                </div>
              </div>
              <hr className="hr-black-color " />
              <div className="table-responsive">
                <Table bordered className="table-centered">
                  <thead className="bg-light text-center">
                    <tr>
                      <th>S.NO</th>
                      <th style={{ minWidth: "350px" }}>Item Name</th>
                      {/* <th>Date</th> */}
                      <th>Status</th>
                      <th>Approved Qty</th>
                      <th>Unit</th>
                      <th>Approved By</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.mri_approvals?.length > 0 ? (
                      data.mri_approvals.map((a, i) => (
                        <tr key={a.id || i}>
                          {/* S.NO */}
                          <td className="text-center">{i + 1}</td>

                          {/* ITEM NAME BLOCK (LIKE IMAGE) */}
                          <td>
                            <div>
                              <strong>{data.product?.name}</strong>
                            </div>

                            {data.make && (
                              <div>
                                <strong>Make :</strong> {data.make}
                              </div>
                            )}

                            {data.description && (
                              <div>
                                <strong>Description :</strong>{" "}
                                {data.description}
                              </div>
                            )}

                            {/* Price Details (optional – render only if available) */}
                            {data.highest_price && (
                              <div className="mt-1">
                                <strong>Highest Price :</strong>{" "}
                                {data.highest_price}
                                <br />
                                <span className="text-muted">
                                  ({data.highest_price_vendor})
                                </span>
                              </div>
                            )}

                            {data.lowest_price && (
                              <div className="mt-1">
                                <strong>Lowest Price :</strong>{" "}
                                {data.lowest_price}
                                <br />
                                <span className="text-muted">
                                  ({data.lowest_price_vendor})
                                </span>
                              </div>
                            )}

                            {data.latest_price && (
                              <div className="mt-1">
                                <strong>Latest Price :</strong>{" "}
                                {data.latest_price}
                                <br />
                                <span className="text-muted">
                                  ({data.latest_price_vendor})
                                </span>
                              </div>
                            )}
                          </td>

                          {/* DATE */}
                          {/* <td className="text-center">
                            {this.formatDate(a.createdon)}
                          </td> */}

                          {/* STATUS */}
                          <td className="text-center">
                            {a.mrstatus_name || "-"}
                          </td>

                          {/* APPROVED QTY */}
                          <td className="text-end">
                            {a.t_qty || a.f_qty || "-"}
                          </td>

                          {/* UNIT */}
                          <td className="text-center">
                            {a.t_unit?.name || data.unit?.name || "-"}
                          </td>

                          {/* APPROVED BY */}
                          <td className="text-center">
                            {a.approvedby?.fullname || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No approvals found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print ">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-1 mr-auto mx-auto" id="toPdf">
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { MRTimeLine_Doc_report } = state.reports;
  return {
    MRTimeLine_Doc_report,
  };
};

export default connect(mapStatetoProps, {
  getMRTimelLineDocReport,
})(MRTimelLineReportDocument);
